import { useEffect, useState } from 'preact/hooks';
import { api } from './api';
import type { Interval, PaidPlanId } from './plans';

/** Server-created Stripe Checkout session; the browser is sent to Stripe's hosted page. */
export async function startCheckout(plan: PaidPlanId, interval: Interval) {
  const { url } = await api<{ url: string }>('/v1/billing/checkout', { method: 'POST', body: { plan, interval } });
  if (!url || !/^https:\/\//.test(url)) throw new Error('Checkout could not be started. Please try again.');
  window.location.assign(url);
}

export const CHECKOUT_UNAVAILABLE = 'Online checkout isn’t available yet. You can keep using the Free plan.';

/** Whether the server has Stripe configured (GET /v1/billing/plans → checkoutAvailable). */
export function useCheckoutAvailable() {
  const [state, setState] = useState<{ available: boolean | null; error: string | null }>({ available: null, error: null });
  useEffect(() => {
    let live = true;
    api<{ checkoutAvailable: boolean }>('/v1/billing/plans')
      .then((r) => live && setState({ available: !!r.checkoutAvailable, error: null }))
      .catch((e) => live && setState({ available: false, error: (e as Error).message }));
    return () => { live = false; };
  }, []);
  return state;
}
